import { render, staticRenderFns } from "./SystemLogging.vue?vue&type=template&id=947bc2cc&"
import script from "./SystemLogging.vue?vue&type=script&lang=js&"
export * from "./SystemLogging.vue?vue&type=script&lang=js&"
import style0 from "./SystemLogging.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports